import { call, put, takeLatest } from 'redux-saga/effects';
import { bookAssessmentSlot, bookAssessmentSlotSettled } from '@containers/Assessment/slice';
import { normalizeAtxBookExamSlotResponse } from '@containers/Drive/DriveHelper';
import { ATX_BOOK_EXAM_SLOT } from '@containers/Drive/queries';
import { catchException, processSagaError } from '@utils/catchException';
import postData from '@utils/postData';
import { handleSagaError, handleSagaSuccess } from '@utils/sagaHelper';
export function* bookAssessmentSlotWorker(action) {
    const { workflowCandidateStepId, driveOccurrenceId, from, to, callback } = action.payload;
    try {
        const response = (yield call(postData, {
            queryString: ATX_BOOK_EXAM_SLOT,
            payload: {
                workflow_candidate_step_id: workflowCandidateStepId,
                drive_occurrence_id: driveOccurrenceId,
                from,
                to,
            },
            spreadPayload: true,
        }));
        const result = normalizeAtxBookExamSlotResponse(response);
        if (!result.success) {
            throw catchException.validationError(result.error_message ?? 'atx_book_exam_slot failed.', {
                workflowCandidateStepId,
                driveOccurrenceId,
            });
        }
        yield call(handleSagaSuccess, { callback: callback?.onSuccess, response: result });
    }
    catch (error) {
        yield call(handleSagaError, {
            callback: callback?.onError,
            error: processSagaError(error, 'An error occurred in bookAssessmentSlotWorker'),
            title: 'Book Assessment Slot Error',
            skipToast: true,
        });
    }
    finally {
        yield put(bookAssessmentSlotSettled());
    }
}
export function* assessmentSlotBookingRootSaga() {
    yield takeLatest(bookAssessmentSlot.type, bookAssessmentSlotWorker);
}
